module.exports = __webpack_public_path__ + "img/reply.a89dacc9.svg";